import type {
  IntegrationAllTabStaticCardsData,
  Option,
} from '../data-layer/types';

const initialIntegrationOptions: Option[] = [
  { label: 'Applications', value: 'Applications' },
  { label: 'Discovery Sources', value: 'Discovery Sources' },
  { label: 'Disconnected  Application', value: 'Disconnected  Application' },
];

export const INTEGRATION_ALL_TAB_STATIC_CARDS_DATA: IntegrationAllTabStaticCardsData[] =
  [
    {
      id: 1,
      name: 'Discovery',
      displayName: 'Discovery',
      description:
        'Prompt users to answer knowledge-based authentication (KBA) questions.',
      kind: 'SelfReview',
      applicationGroup: '',
      status: 'active',
    },
    {
      id: 2,
      name: 'Application',
      displayName: 'Create New Application',
      description:
        'Prompt users to answer knowledge-based authentication (KBA) questions.',
      kind: 'SavedRequests',
      applicationGroup: '',
      status: 'active',
    },
  ];

export default initialIntegrationOptions;
